import PropTypes from "prop-types";
import React, { useState } from "react";
import styles from "./IBOItem.module.css";
import select from "./icons/Select.svg";
import chevron from "./icons/Chevron.svg";
import trendUp from "./icons/TrendUp.svg";
import trendDown from "./icons/TrendDown.svg";
import trendFlat from "./icons/TrendFlat.svg";
import { ReactComponent as EagleTrackerIcon } from "../../components/icons/EagleTrackerIcon.svg";
import { ReactComponent as DoubleEagleIcon } from "../../components/icons/DoubleEagleIcon.svg";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

export const IBOItem = ({
  pinLevel,
  firstNames,
  lastNames,
  avatars,
  onClick,
  onSelect,
  selected,
  trend,
  isEagle,
  isDoubleEagle,
  isComplimentary,
}) => {
  const handleSelect = () => {
    if (onSelect) onSelect();
  };
  const {t} = useTranslation();

  return (
    <div
      className={`${styles.item_row} ${
        (onClick && pinLevel !== 1) || onSelect ? styles.pointer : ""
      }`}
      onClick={
        onClick && pinLevel !== 1
          ? onClick
          : onSelect
          ? handleSelect
          : undefined
      }
    >
      {onSelect && (
        <span className={styles.selected_icon}>
          {selected ? (
            <FontAwesomeIcon icon={faCheckCircle} />
          ) : (
            <img src={select} />
          )}
        </span>
      )}

      <div className={styles.avatar_container}>
        {avatars.map((img, index) => (
          <img
            key={index}
            src={img}
            className={avatars.length > 1 ? styles.avatar : ""}
          />
        ))}
      </div>

      <div className={styles.ibo_info}>
        <div className={styles.first_names}>
          {firstNames.map((name, index) =>
            firstNames.length > 1 && index === 0 && lastNames.length === 1 ? (
              <span>{name} &</span>
            ) : firstNames.length > 1 && index === 1 && lastNames.length > 1 ? (
              <span className={styles.margin_left}>{name}</span>
            ) : (
              <span>{name}</span>
            )
          )}
        </div>
        <div className={styles.last_names}>
          {lastNames.map((name) => (
            <span className={styles.last_name}>{name}</span>
          ))}
        </div>

        <div className={styles.pin_level}>
          {pinLevel === 1 ? (
            <span
              className={isComplimentary ? styles.complimentary : styles.ibo}
            >
              {isComplimentary && "Complimentary "}IBO
            </span>
          ) : pinLevel === 2 ? (
            <span className={styles.platinum}>
              {isComplimentary && "Complimentary "}{t("Platinum")}
            </span>
          ) : pinLevel === 3 ? (
            <span className={styles.emerald}>
              {isComplimentary && "Complimentary "}{t("Emerald")}
            </span>
          ) : pinLevel === 4 ? (
            <span className={styles.diamond}>
              {isComplimentary && "Complimentary "}{t("Diamond")}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>

      <span className={styles.eagleicon}>
        {isEagle && <EagleTrackerIcon />}
        {isDoubleEagle && <DoubleEagleIcon />}
      </span>

      <span className={styles.trend}>
        {trend === "up" ? (
          <img src={trendUp} />
        ) : trend === "down" ? (
          <img src={trendDown} />
        ) : trend === "same" ? (
          <img src={trendFlat} />
        ) : (
          <div className={styles.filler2} />
        )}
      </span>

      {onClick && pinLevel !== 1 ? (
        <img src={chevron} className={styles.chevron} />
      ) : !onSelect ? (
        <div className={styles.filler} />
      ) : null}
    </div>
  );
};

IBOItem.propTypes = {
  pinLevel: PropTypes.number,
  firstName: PropTypes.arrayOf(PropTypes.string),
  lastName: PropTypes.arrayOf(PropTypes.string),
  avatars: PropTypes.array,
  onSelect: PropTypes.func,
  isSelected: PropTypes.bool,
  trend: PropTypes.oneOf(["up", "down", "flat"]),
  isFreeTrial: PropTypes.bool,
};
